export default __webpack_public_path__ + "static/media/get_it_on_google_play_new.13ccec36.png";